import { useState } from "react";
import { Download, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { apiError } from "@/lib/api";
import { descargarArchivo } from "@/lib/migracion";

export function PasoPlantilla() {
  const [bajando, setBajando] = useState(false);
  const bajar = async () => {
    setBajando(true);
    try {
      await descargarArchivo("/migracion-cartera/plantilla", "plantilla_migracion_cartera.xlsx");
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setBajando(false);
    }
  };
  return (
    <section className="rounded-lg border border-slate-200 bg-white p-5" data-testid="migracion-paso-plantilla">
      <p className="text-xs font-semibold uppercase tracking-wide text-slate-400">Paso 1</p>
      <h2 className="mt-1 text-base font-semibold text-slate-900">Plantilla de migración</h2>
      <p className="mt-1 max-w-3xl text-sm text-slate-600">
        Captura en la hoja «Clientes» a tus personas físicas, una por fila, con los mismos campos del alta de
        clientes. Si un cliente ya existe en FELVORA (mismo RFC o CURP) no se duplica: se vincula al registro existente.
      </p>
      <p className="mt-1 max-w-3xl text-sm text-slate-600">
        En la hoja «Creditos» (y «Integrantes» para grupales) van los créditos que ya otorgaste en tu sistema anterior,
        con su fecha original y sus cuotas ya pagadas; el cliente debe existir en FELVORA o venir en la hoja «Clientes».
        Las hojas de instrucciones dicen qué es obligatorio y qué valores acepta cada catálogo.
      </p>
      <Button variant="outline" size="sm" className="mt-3 gap-2" onClick={bajar} disabled={bajando}
        data-testid="migracion-descargar-plantilla">
        {bajando ? <Loader2 className="h-4 w-4 animate-spin" /> : <Download className="h-4 w-4" />}
        Descargar plantilla
      </Button>
    </section>
  );
}
